<p-confirmDialog key="person" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="personreset" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="personconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Remove</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleAll(1)">Activate Selected</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleAll(0)">Deactivate Selected</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />

		<label *ngIf="SelectedStationReminderAlert == undefined" class="TitleLabel">Select a Reminder</label>
		<label *ngIf="SelectedStationReminderAlert != undefined" class="TitleLabel"
			>Assigned Students and Staff
			<span style="margin-left: 15px" [style.color]="SelectedStationReminderAlert == undefined ? 'Black' : SelectedStationReminderAlert.MessageFontColor"
				>({{ SelectedStationReminderAlert?.Message }})</span
			></label
		>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="ShowInfo == true ? 'block' : 'none'">
		<label>&#9900; NOTE: You must select an entry in the top table to use this table </label><br />
		<br />
		<label>Buttons:</label><br />
		<label
			>&#9900; Add: Opens a popup where you can select students and staff from the person selector. Students and staff are add to a list. Pressing Assign
			Reminder at the bottom of the popup finishes adding people to the reminder.</label
		><br />
		<label
			>&#9900; Remove: Removes selected students from the list. NOTE: You will no longer be able to see whether or not they received the alert. You might
			want to deactivate students rather than delete them.</label
		><br />
		<label
			>&#9900; Activate Selected: Select students then press activate to set them to active. It will also open a popup giving you the option to RESET
			whether or not the reminder was Already Played (They will all get set to not played yet if you press yes.)</label
		><br />
		<label
			>&#9900; Deactivate Selected: Deactivate students so they won't see the reminder but will still be in the list and you'll be able to see whether or
			not they received the reminder.</label
		><br />
		<br />
		<label>Table Columns:</label><br />
		<label
			>&#9900; Already Played: Whether or not the reminder was displayed when the student scanned. If this is true and it is a "Play Once" reminder it
			will no longer display. Other types of reminders can play multiple times. NOTE: To RESET whether a reminder has already played, select the reminders
			you want to reset then press the Activate Reminder and a popup will ask if you want to reset whether the reminders were played or not.</label
		><br />
		<label
			>&#9900; Active: Whether or not the reminder will continue playing. This can be toggle manually by student. NOTE: deactivating the reminder is only
			way to stop playing "Play Until Removed" reminders.</label
		><br />
		<br />
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPersons"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->
				<!--ID-->
				<th>
					<p-columnFilter type="text" field="ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonTypeDesc-->
				<th>
					<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPersonTypeDesc
								[ngModel]="value"
								[options]="lstPersonTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AlreadyPlayedDesc-->
				<th class="fixwidth-09">
					<p-columnFilter field="AlreadyPlayedDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlreadyPlayedDesc
								[ngModel]="value"
								[options]="lstAlreadyPlayedDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--GroupName-->
				<th>
					<p-columnFilter field="GroupName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGroupName
								[ngModel]="value"
								[options]="lstGroupName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ID">Student/Staff ID<p-sortIcon field="ID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="PersonTypeDesc">Person Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="AlreadyPlayedDesc">Already Played<p-sortIcon field="AlreadyPlayedDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="c_date">Last Updated<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="GroupName">Assigned by Group<p-sortIcon field="GroupName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<!-- <div *ngIf="Person.AlreadyPlayed == true" class="fixwidth-09">
						<i class="pi pi-check-circle table-active table-icon"></i>						
					</div>
                
                    <div *ngIf="Person.AlreadyPlayed == false" class="fixwidth-09">
						<i class="pi pi-ban table-inactive table-icon"></i>						
					</div> -->

					<input class="CHK" type="checkbox" [(ngModel)]="Person.AlreadyPlayed" disabled />
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Person.Active == true ? 'Black' : 'Red'">
					{{ Person.ActiveDesc }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
